import React from "react";

export function RefreshIcon({ fill, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 2V5H13" stroke="#231F20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M16.027 5.175C14.67 2.688 12.032 1 9 1C4.582 1 1 4.582 1 9C1 13.418 4.582 17 9 17C13.418 17 17 13.418 17 9"
        stroke="#231F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
